import { z } from "zod";

export const journeyStatusSchema = z.enum(["ACTIVE", "ARCHIVED", "DRAFT", "COMPLETED"]);
export type JourneyStatus = z.infer<typeof journeyStatusSchema>;

export type Journey = {
  id: string;
  title: string;
  slug: string;
  description: string | null;
  isOnboarding: boolean;
  partnerId: string;
  createdAt: Date;
  updatedAt: Date;
  status: JourneyStatus;
  playbookId: string | null;
  promptId: string | null;
};

export type AtomOfThought = {
  id: string;
  playbookId?: string | null; // Optional foreign key to playbook
  journeyId?: string | null; // Optional foreign key to journey
  type: string; // the type of thought, can be domain-specific like "Gnosis Evaluation" or generic like the default, "thought"
  content: string | null; // typically just simple markdown text
  format: string; // default is md
  createdAt: Date;
  updatedAt: Date;
};

export type AtomOfThoughtMetadata = {
  id: string;
  key: string;
  value: string | null;
  createdAt: Date;
  updatedAt: Date;
};

export type AtomOfThoughtWithMetadata = AtomOfThought & {
  metadata: AtomOfThoughtMetadata[];
};

export type JourneyWithAot = Journey & {
  atomsOfThought: AtomOfThoughtWithMetadata[];
};

export type JourneyCreate = Pick<Journey, "title" | "description" | "isOnboarding" | "partnerId" | "status"> & {
  promptId?: string | null | undefined;
  playbookId?: string | null | undefined;
};

export type JourneyUpdate = Omit<JourneyCreate, "partnerId"> & { id: string };

export const journeyCreateSchema = z.object({
  title: z.string(),
  description: z.string().nullable(),
  isOnboarding: z.boolean(),
  partnerId: z.string(),
  status: journeyStatusSchema,
  promptId: z.string().nullable().optional(),
  playbookId: z.string().nullable().optional(),
}) satisfies z.ZodType<JourneyCreate>;

export const journeyUpdateSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  isOnboarding: z.boolean(),
  status: journeyStatusSchema,
}) satisfies z.ZodType<JourneyUpdate>;
